import React from 'react';
import DekorInput from '../commons/DekorInput.jsx'
import SidebarFrame from "./SidebarFrame";

export default class DekorSettings extends SidebarFrame {

    renderTitle() {
        return I18N("Dekore");
    }

    renderBody() {
        return (
            <div>
                {APP.getDekorTypenUsed()
                    .filter(dekortyp=>APP.getMaterialsForDekorTyp(dekortyp.Name).length>1)
                    .map((dekortyp,index)=>(
                    <DekorInput key={index}
                                label={I18N(`Welches ${dekortyp.Anzeigename} Dekor wünschen Sie?`)}
                                dekore={APP.getMaterialsForDekorTyp(dekortyp.Name)}
                                value={APP.arrangement.materials[dekortyp.Name]}
                                appear={true}
                                setValue={(value, option) => {
                                    APP.deleteMaterialsRecursive(APP.arrangement,dekortyp.Name);
                                    APP.arrangement.materials[dekortyp.Name]=value;
                                    APP.model.setDirty();
                                }}
                                />
                ))}
            </div>
        )
    }

}
